import RadioGroup from "slotworks/components/ui/radio-group";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractRadioControl extends AbstractControl implements Control {

    protected radioGroup: RadioGroup<any>;

    private currentValues: any[];
    private currentDefaultValue: any;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        const radioButtons = [];
        const radioLabels = [];

        do {
            const n = radioButtons.length + 1;
            const radioButton = layer.getFlexiButton(assetName + "_" + n);
            const radioButtonLabel = layer.getFlexiText(assetName + "_" + n + "_label");

            if (!radioButton) {
                break;
            } else {
                radioButtons.push(radioButton);
                radioLabels.push(radioButtonLabel);
            }
        } while (true);

        if (radioButtons.length > 0) {
            const rightButton = layer.getFlexiButton(assetName + "_right");
            const leftButton = layer.getFlexiButton(assetName + "_left");
            const rightPageButton = layer.getFlexiButton(assetName + "_right_page");
            const leftPageButton = layer.getFlexiButton(assetName + "_left_page");

            this.radioGroup = new RadioGroup(radioButtons, radioLabels, rightButton, leftButton, rightPageButton, leftPageButton);
            this.radioGroup.onChange.add(this.onChangeHandler);
        } else {
            this.error("no radio buttons found for " + assetName);
        }
    }

    public updateValues<T>(values: T[], defaultValue: T) {
        if (this.currentValues === values && this.currentDefaultValue === defaultValue) {
            return;
        }

        this.currentValues = values;
        this.currentDefaultValue = defaultValue;

        this.radioGroup.updateValues(values, defaultValue);
    }

    public destroy() {
        if (this.radioGroup) {
            this.radioGroup.destroy();
            this.radioGroup = null;
        }
    }

    public setVisible(visible: boolean) {
        this.radioGroup.setVisible(visible);
    }

    public setEnabled(enabled: boolean): void {
        super.setEnabled(enabled);
        this.radioGroup.setEnabled(enabled);
    }

    protected onChangeHandler = (value: number) => {
        this.onChange.dispatch(value);
    }
}
